import React from 'react';

import { Dialog } from '@mui/material';

import { STOItem } from 'commons/types';

import S from './RemoveSTOPickItemDialog.styles';

export interface IRemoveSTOPickItemDialogProps {
  item: STOItem | null;
  onClose: () => void;
  onConfirm: (item: STOItem) => void;
  openModal: boolean;
}

export const RemoveSTOPickItemDialog: React.FC<
  IRemoveSTOPickItemDialogProps
> = ({ item, onClose, onConfirm, openModal }) => {
  // immediate return if null
  if (!item) {
    onClose();
    return <div />;
  }

  return (
    <Dialog onClose={onClose} open={openModal}>
      <S.TitleWrapper>
        <S.Title>REMOVE SKU</S.Title>
      </S.TitleWrapper>

      <S.Text>
        Are you sure to remove SKU <b>{item.sku_code}</b> from your list?
      </S.Text>

      {/* Footer */}
      <S.FooterWrapper>
        <S.CancelButton onClick={onClose}>NO</S.CancelButton>
        <S.OKButton onClick={() => onConfirm(item)}>YES</S.OKButton>
      </S.FooterWrapper>
    </Dialog>
  );
};

export default RemoveSTOPickItemDialog;
